import {IEntity} from './entity'
import { mapDateFromApi } from 'src/core/utils'
import { mapPaginationFromApi } from './paginated'


export interface INews extends IEntity {
    id: string;
    target_id: string;
    target_type: string;
    publish_at: Date;
    title?: string;
    message?: string;
    img_url?: string;
    youtube_url?: string;
    content_url?: string;
    is_report?: boolean;
    category_actu?: string;
    category_actu_nuage?: string;
    category_produit?: string;
    category_principale?: string;
    is_public: boolean;
    is_private: boolean;
    is_highlighted: boolean;
    tag?: string;
    custom?: NewsCustom;
    author: Author;
    documents: NewsDocument[];
}

export interface NewsCustom {

}

export interface Author extends IEntity{
    id: string;
    email: string;
    first_name: string;
    last_name: string
}

export interface NewsDocument extends IEntity{
    id: string;
    name: string;
    permalink: string;
    content_type: string;
    description: string;
}

export interface ICloud extends IEntity {
    value: string;
    count: number;
}

export enum EcoWatch {
    PME = "PME",
    FPP = "FPP",
    HEBDO = "HEBDO"
}

export const defaultMapFilter = new Map([["actu-nuage", []], ["actu", []], ["produit", []], ["principale", []]]);
export const defaultMapPME = new Map([["actu-nuage", []], ["actu", ["economique","ORpme-change,pme-dette,pme-placement"]], ["produit", []], ["principale", []]]);
export const defaultMapFPP = new Map([["actu-nuage", []], ["actu", ["economique","ORpoints,focus,perspectives"]], ["produit", []], ["principale", []]]);
export const defaultMapHEBDO = new Map([["actu-nuage", []], ["actu", ["economique","NOTpme-change,NOTpme-dette,NOTpme-placement,NOTpoints,NOTfocus,NOTperspectives"]], ["produit", []], ["principale", []]]);

export const mapNewsFromApi = (apiNews: any): INews => ({
    ...apiNews,
    publish_at: mapDateFromApi(apiNews.publish_at)
});

export const mapNewsPaginationFromApi = mapPaginationFromApi<INews>(mapNewsFromApi)

export const mapCloudFromApi = (v: string, c: number): ICloud => ({
    value: v,
    count: c
})

export const mapCloudsFromApi = (apiClouds: any): ICloud[] => {
    return Object.keys(apiClouds).map(obj => mapCloudFromApi(obj, apiClouds[obj]))
}


// WEBPACK FOOTER //
// ./src/type/news.ts